<template>
  <v-card-title>
    <v-container class="pa-12">
      <v-card class="pl-16 pr-16 pt-8 pb-16">
        <!-- <div fill-width class="pb-5" align="end" v-if="false">
          <v-btn
            class="mx-2"
            fab
            dark
            color="#689ADE"
            @click="saveAdvanceDraft()"
          >
            <v-icon color="black">
              mdi-close
            </v-icon>
          </v-btn>
        </div> -->
        <v-card-title>
          <v-row>
            <v-col cols="6" md="6" justify="center">
              <h3>{{ this.doc_title }}</h3>
            </v-col>
            <v-col cols="6" md="6">
              <v-row>
                <v-col class="text-right" cols="12" md="12">
                  <h5>No. {{ advance_h.advance_id }}</h5>
                  <h5>Date. {{ advance_date_show }}</h5>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-title>

        <v-simple-table>
          <!-- table top section -->
          <template v-slot:top>
            <v-row class="row1 heightsize70formadvance">
              <v-col cols="12" md="6">
                <v-text-field v-model="setusername" outlined disabled dense label="Employee Name"
                  background-color="#F5F5F5"></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="department_view" outlined disabled dense label="Department"
                  background-color="#F5F5F5"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="row1 heightsize70formadvance">
              <v-col cols="12" md="6">
                <v-autocomplete v-model="emp_draw" :items="emp_list" item-text="name" item-value="id" label="ผู้เบิก"
                  outlined dense disabled background-color="#F5F5F5"></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="4" md="6">
                <v-autocomplete v-model="emp_draw_jobtitle" :items="jobtitle_list" item-text="name" item-value="id"
                  label="Assignment / Case" outlined dense disabled background-color="#F5F5F5"></v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
              <v-col cols="12" md="6">
                <v-autocomplete v-model="customer_name" :items="customer_list" outlined dense :disabled="mode_approve"
                  label="For Client" @change="onSelectCustomerChange(customer_name)"></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="4" md="4">
                <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                  offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedExpectedClearDateFormatted" label="Expected Clear Date"
                      append-icon="mdi-calendar" readonly dense :disabled="mode_approve" outlined v-bind="attrs"
                      v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <br />
          </template>
        </v-simple-table>
        <template>
          <template>
            <v-data-table :headers="headers" :items="desserts" sort-by="calories" class="elevation-1"
              hide-default-footer hide-default-header>
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th v-for="h in headers" :class="h.class">
                      <span>{{ h.text }}</span>
                    </th>
                  </tr>
                </thead>
              </template>

              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Advance Details</v-toolbar-title>
                  <!-- <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer> -->
                  <v-dialog v-model="dialog" max-width="500px">
                    <!-- <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        New Item
                      </v-btn>
                    </template> -->
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field v-model="editedItem.name" label="Dessert name"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field v-model="editedItem.calories" label="Calories"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field v-model="editedItem.fat" label="Fat (g)"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field v-model="editedItem.carbs" label="Carbs (g)"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field v-model="editedItem.protein" label="Protein (g)"></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">
                          Cancel
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="save">
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                      <v-card-title class="text-h5">Are you sure you want to delete this
                        item?</v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                <!-- <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon> -->

                <v-btn @click="deleteItem(item)" :disabled="mode_approve" :style="{
                  backgroundColor: '#9E3B1B',
                  color: 'white',
                }">
                  <v-icon small> mdi-delete </v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="initialize"> Reset </v-btn>
              </template>
              <template v-slot:item.actions="{ item }">
                <!-- <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon> -->

                <v-btn @click="deleteItem(item)" :disabled="mode_approve" :style="{
                  backgroundColor: '#9E3B1B',
                  color: 'white',
                }">
                  <v-icon small> mdi-delete </v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="initialize"> Reset </v-btn>
              </template>
              <template v-slot:item.description="{ item }">
                <span @click="openPreviewMaps(item.description)" class="description-text">
                  {{ item.description }}
                </span>
              </template>
            </v-data-table>
          </template>
          <div class="pl-2 pr-2 pt-2 elevation-1 heightsize55formadvance">
            <template>
              <v-row v-if="mode_edit">
                <v-col cols="12" sm="2" md="2">
                  <!-- <v-text-field
                    v-model="editedItem.advance_title"
                    ref="txtCode"
                    label="Code"
                    dense
                    outlined
                    :disabled="mode_approve"
                    @keydown.space="changeFocusText(2)"
                    @keydown.enter="changeFocusText(2)"
                  ></v-text-field> -->

                  <v-autocomplete v-model="editedItem.advance_title" :items="advance_code_list" ref="txtCode" outlined
                    dense :label="editedItem.advance_title" @change="
                      onSelectAdvanceCodeChange(editedItem.advance_title)
                      " @keydown.enter="changeFocusText(2)"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="7" md="7">
                  <v-text-field v-model="editedItem.description" ref="txtDescription" dense outlined label="Description"
                    @keydown.enter="changeFocusText(3)"></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                  <v-text-field v-model="editedItem.amount" ref="txtAmount" label="Amount" type="number" dense outlined
                    @keydown.enter="save()"></v-text-field>
                </v-col>
              </v-row>
            </template>
          </div>
        </template>

        <br />
        <v-row class="heightsize55formadvance">
          <v-col class="text-right" cols="12" md="4"> </v-col>
          <v-col class="text-right" cols="12" md="4">Total </v-col>
          <v-col class="text-right" cols="12" md="4">
            <v-row>
              <v-col cols="12" md="12">
                <v-row>
                  <v-col class="text-right" cols="12" md="12">
                    <!--:suffix="sumwithdrawamount" -->
                    <v-text-field reverse filled disabled outlined dense v-model="sumwithdrawamount"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row align="start" justify="start">
          <v-col cols="12" md="6">
            <v-radio-group v-model="radioGroup" @change="changeradio()" :disabled="mode_approve">
              <v-radio key="bank" label="Transfer" value="bank"></v-radio>
              <v-col v-show="pickbank">
                <v-autocomplete v-model="selectbankname" :items="bankname" label="Select Bank" outlined
                  dense></v-autocomplete>
                <v-text-field outlined dense v-model="bankNumber" label="Account Number"></v-text-field></v-col>

              <v-radio key="cash" label="Cash" value="cash"></v-radio>

              <v-radio key="cheque" label="Cheque" value="cheque"></v-radio>
              <v-col v-show="pickcheque">
                <v-text-field outlined dense label="Cheque No" v-model="chequeNumber"></v-text-field>
              </v-col>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row>
          <v-text-field v-model="remark" :disabled="mode_approve" fill-width outlined dense
            label="Remark"></v-text-field>
        </v-row>
        <v-row>
          <v-text-field v-model="approver_remark" :disabled="!mode_approve" fill-width outlined dense
            label="Remark Approve" ref="reject approve"></v-text-field>
        </v-row>

        <v-row>
          <v-col align="center" cols="12" md="4">
            <v-row v-if="dialogSignature" :style="{ visibility: showsig1 ? 'visible' : 'hidden' }">
              <VueSignaturePad class="signature" width="90%" height="200" ref="firstsignaturePad" :options="options" />
              <v-row :style="{
                visibility: showbuttonsavesig1 ? 'visible' : 'hidden',
              }">
                <v-col align="center">
                  <v-btn depressed class="ml-5" @click="clearsig1()">
                    Clear
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn class="mr-5 mb-5 primary" depressed @click="savesig1()">
                    Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-row>
            <v-btn class="mr-2 mb-5" @click="editsig1()" :disabled="mode_approve">
              {{ defaultwordbuttonsig1 }}
              <v-icon right>mdi-border-color</v-icon>
            </v-btn>
            <br />
            <hr />
            <p class="text-center">Requester</p>
            <p class="text-center" v-if="lbl_date_request">
              Date {{ advance_date_show }}
            </p>
          </v-col>

          <v-col align="center" cols="12" md="4">
            <v-row v-if="dialogSignature" :style="{ visibility: showsig2 ? 'visible' : 'hidden' }">
              <VueSignaturePad class="signature" width="90%" height="200" ref="secondsignaturePad" :options="options" />
              <v-row :style="{
                visibility: showbuttonsavesig2 ? 'visible' : 'hidden',
              }">
                <v-col align="center">
                  <v-btn depressed class="ml-5" @click="clearsig2()">
                    Clear
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn class="mr-5 mb-5 primary" depressed @click="savesig2()">
                    Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-row>
            <!-- v-if="this.role !== 'EMPLOYEE'" -->
            <v-row class="mr-2 mb-3" v-if="!mode_approve" />
            <v-btn v-if="mode_approve" class="mr-2 mb-5" @click="editsig2()">
              {{ defaultwordbuttonsig2 }}
              <v-icon right>mdi-border-color</v-icon>
            </v-btn>

            <br />
            <hr />
            <p class="text-center">Approver</p>
            <p class="text-center" v-if="mode_approve">
              Date {{ dateCurrent }}
            </p>
          </v-col>
          <v-col align="center" cols="12" md="4" class="mt-6">
            <v-row v-if="dialogSignature" :style="{ visibility: showsig3 ? 'visible' : 'hidden' }">
              <VueSignaturePad class="signature" width="90%" height="200" ref="thirdsignaturePad" :options="options" />
              <v-row :style="{
                visibility: showbuttonsavesig3 ? 'visible' : 'hidden',
              }">
                <v-col align="center">
                  <v-btn depressed class="ml-5" @click="clearsig2()">
                    Clear
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn class="mr-5 mb-5 primary" depressed @click="savesig2()">
                    Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-row>
            <!-- <v-btn
              v-if="this.role !== 'EMPLOYEE'"
              class="mr-2"
              @click="editsig2()"
            >
              {{ defaultwordbuttonsig2 }}
              <v-icon right>mdi-border-color</v-icon>
            </v-btn> -->
            <br />

            <hr />
            <p class="text-center">Accountant</p>
            <!-- <p class="text-center">Date {{ dateCurrent }}</p> -->
          </v-col>
        </v-row>
        <br />
        <hr />
        <br />
        <div v-if="mode_edit" :style="{ display: mode_edit ? 'show' : 'none' }">
          <v-row>
            <v-col align="center" cols="12" md="12">
              <v-btn depressed class="mr-5 buttonblue" @click="saveAdvanceRequest()">
                Submit Request
              </v-btn>

              <v-btn depressed @click="updateRequest(5)">
                Cancel Request
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col align="end" cols="12" md="12">
              <v-btn depressed class="buttonred" @click="dialogDeleteForm = true">
                Delete form
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <div v-if="mode_approve" :style="{ display: mode_approve ? 'show' : 'none' }">
          <v-row>
            <v-col align="center" cols="12" md="12">
              <v-btn depressed class="mr-5 buttonred" @click="updateApprove(4)">
                Reject
              </v-btn>
              <v-btn depressed class="mr-5 buttonblue" @click="updateApprove(3)">
                Approve
              </v-btn>

              <v-btn depressed @click="updateApprove(1)" style="border: 1px solid black">
                Return To Adjust
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>

      <v-dialog v-model="dialogDeleteForm" max-width="500px">
        <v-card>
          <v-card-title class="text-h6">Are you sure you want to delete this Advance?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDeleteForm">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirmForm">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogSendMail" max-width="500px">
        <v-card>
          <v-card-title class="text-h6">Information Saved</v-card-title>
          <v-card-subtitle>
            บันทึกข้อมูลและส่งอีเมล์ถึงผู้อนุมัติสำเร็จ
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="blue darken-1" text @click="closeDeleteForm"
              >Cancel</v-btn
            > -->
            <v-btn color="blue darken-1" text @click="closeDialogSendmail()">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogSaveDraft" max-width="30%">
        <v-card>
          <v-card-title primary-title class="justify-center">
            {{ this.messageSaveDraft }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="blue darken-1" text @click="closeSaveDraft"
                          >Cancel</v-btn
                        > -->
            <v-btn color="blue darken-1" text @click="closeSaveDraft">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
      <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
    </v-container>
  </v-card-title>
</template>

<script>
import api from "@/services/api";
import { server } from "../services/constants";
import StockCard from "@/components/cards/StockCard";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import unity from "@/unity/unity";

export default {
  name: "approve-advance",
  data() {
    return {

      jobtitle_list: [],
      emp_list: [],
      emp_draw: 0,
      emp_draw_jobtitle: 0,
      close_status: false,
      doc_title: "",
      mode_edit: false,
      mode_approve: false,
      advance_code: [],
      advance_code_list: [],
      advance_code_id: 0,
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      customer: [],
      customer_list: [],
      customer_id: 0,
      options: {
        penColor: "#000000",
        backgroundColor: "rgb(255,255,255)",
      },
      user_sign: "",
      user_sign2: "",
      initial_data: "",
      pickbank: false,
      pickcheque: false,
      checkcheque: false,
      checkchequefilled: false,
      showsig1: false,
      showsig2: false,
      showsig3: false,
      showbuttonsavesig1: false,
      showbuttonsavesig2: false,
      showbuttonsavesig3: false,
      defaultwordbuttonsig1: "Signature",
      defaultwordbuttonsig2: "Signature",
      totalleftoveramount: 0.0,
      sumwithdrawamount: 0.0,
      sunamountcleared: 0.0,
      showallamount: "",
      desserts: [
        {
          no: "1",
          detail: "",
          withdrawamount: 0,
        },
      ],
      selectbankname: "",
      bankname: [
        "ธนาคารกรุงเทพ",
        "ธนาคารกสิกรไทย",
        "ธนาคารกรุงไทย",
        "ธนาคารทหารไทยธนชาต",
        "ธนาคารไทยพาณิชย์",
        "ธนาคารกรุงศรีอยุธยา",
        "ธนาคารเกียรตินาคินภัทร",
        "ธนาคารซีไอเอ็มบีไทย",
        "ธนาคารทิสโก้",
        "ธนาคารยูโอบี",
        "ธนาคารไทยเครดิตเพื่อรายย่อย",
        "ธนาคารแลนด์ แอนด์ เฮ้าส์",
        "ธนาคารไอซีบีซี (ไทย)",
        "ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย",
        "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร",
        "ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย",
        "ธนาคารออมสิน",
        "ธนาคารอาคารสงเคราะห์",
        "ธนาคารอิสลามแห่งประเทศไทย",
      ],
      radioType: ["cash", "cheque"],
      radioGroup: "",
      setusername: "",
      role: localStorage.getItem(server.ROLE),
      department: "",
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateCurrent: unity.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      ),
      menu: false,
      modal: false,
      menu2: false,
      search: "",
      selectedProductId: "",
      confirmDeleteDlg: false,
      mDataArray: [],
      // mDataArray: [{ id: "1", detail: "gg", amout: "1000" }],
      fullPage: true,
      dialog: false,
      dialogDelete: false,
      dialogDeleteForm: false,
      dialogSendMail: false,
      headers: [
        {
          text: "Code",
          value: "advance_title",
          class: "my-header4-style ",
        },
        {
          text: "Description",
          value: "description",
          class: "my-header-style",
        },
        { text: "Amount", value: "amount", class: "my-header2-style " },
        {
          text: "Action",
          value: "actions",
          class: "my-header3-style  text-center",
        },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        code: "",
        description: "",
        amount: 0,
      },
      defaultItem: {
        code: "",
        description: "",
        amount: 0,
      },
      advance_d: {
        advance_hid: "",
        advance_title: "",
        description: "",
        amount: 0,
      },
      advance_h: {
        advance_id: "",
        customer_id: 0,
        employee_id: 0,
        department_id: 0,
        advance_date: null,
        sum_amount: 0,
        clear_date: null,
        payment_type: null,
        bank_name: null,
        bank_number: null,
        cheque_number: null,
        status: null,
        remark: null,
        approver_remark: null,
        create_by: null,
        create_date: null,
      },
      advance_h_update_status: {
        status: null,
        approver_remark: null,
      },
      advance_h_update_approve: {
        status: null,
        remark: null,
      },
      lbl_date_request: false,
      dialogSignature: false,
      dialogSaveDraft: false,
      messageSaveDraft: "",
      paymentType: "",
      bankName: "",
      bankNumber: "",
      chequeNumber: "",
      remark: "",
      approver_remark: "",
      main_id: "",
      customer_name: "",
      sendMail: {
        name: "",
        email: "",
        advance_id: "",
        link: "",
      },
      account: {
        signature: "",
      },
      advance_log: {
        module: "AD",
        module_id: 0,
        approve_id: 0,
        approve_status: 0,
        approve_date: null,
      },
      department_view: "",
      advance_date_show: "",
    };
  },
  components: {
    StockCard,
    SuccessDialog,
    SuccessDialogPush,
  },
  computed: {
    version() {
      return this.initial_data;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    computedExpectedClearDateFormatted() {
      return unity.formatDate(this.date);
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async mounted() {
    //console.log("STEP 1: เริ่ม mounted");

    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    //console.log("STEP 2: ผ่าน auth check แล้ว");

    this.$store.state.navMenu = true;
    this.main_id = this.$route.params.id;
    //console.log("STEP 3: main_id =", this.main_id);

    const res_h = await api.billing_expense_getAllHById(this.main_id);
    //console.log("STEP 4: res_h =", JSON.stringify(res_h.data));

    this.advance_h.advance_id = res_h.data[0].advance_id;
    this.advance_h.customer_id = res_h.data[0].customer_id;
    this.advance_h.employee_id = res_h.data[0].employee_id;
    this.emp_draw = res_h.data[0].emp_draw;
    this.emp_draw_jobtitle = res_h.data[0].emp_draw_jobtitle;
    this.advance_h.employee_id = res_h.data[0].employee_id;
    this.advance_h.department_id = res_h.data[0].department_id;
    this.sumwithdrawamount = res_h.data[0].sum_amount;

    this.advance_h.payment_type = res_h.data[0].payment_type;
    this.advance_h.bank_name = res_h.data[0].bank_name;
    this.advance_h.bank_number = res_h.data[0].bank_number;
    this.advance_h.cheque_number = res_h.data[0].cheque_number;

    this.bankNumber = this.advance_h.bank_number;
    this.selectbankname = this.advance_h.bank_name;
    this.chequeNumber = this.advance_h.cheque_number;
    //console.log("STEP 5: set ค่า advance_h จาก header เสร็จ");

    if (this.advance_h.payment_type === "cheque") {
      this.paymentType = "cheque";
      this.pickbank = false;
      this.pickcheque = true;
      this.radioGroup = "cheque";
    } else if (this.advance_h.payment_type === "transfer") {
      this.paymentType = "transfer";
      this.pickcheque = false;
      this.pickbank = true;
      this.radioGroup = "bank";
    } else {
      this.paymentType = "cash";
      this.pickcheque = false;
      this.pickbank = false;
      this.radioGroup = "cash";
    }
    //console.log("STEP 6: set payment_type =", this.advance_h.payment_type);

    this.advance_h.status = res_h.data[0].status;
    this.advance_h.remark = res_h.data[0].remark;
    this.remark = res_h.data[0].remark;
    this.advance_h.create_by = res_h.data[0].create_by;
    this.advance_h.create_date = res_h.data[0].create_date;

    this.advance_h.advance_date = res_h.data[0].advance_date;
    this.advance_date_show = unity.formatDate(res_h.data[0].advance_date);
    this.advance_h.clear_date = res_h.data[0].clear_date;
    //console.log("STEP 7: set advance_date/clear_date เสร็จ, clear_date =", this.advance_h.clear_date);

    const res_d = await api.billing_expense_getAllDById(this.$route.params.id);
    this.desserts = res_d.data;
    //console.log("STEP 8: res_d length =", res_d.data ? res_d.data.length : "ไม่มี data");

    this.$forceUpdate();
    this.initialize();
    this.loadEmp();
    this.loadJobtitle();
    this.loadCustomer();
    this.loadAdvanceCode();
    //console.log("STEP 9: เรียก initialize/load ต่างๆ เสร็จ");

    let id = null;
    if (this.$route.params.mode === "approve") {
      id = this.advance_h.employee_id;
    } else {
      id = localStorage.getItem(server.USER_ID);
    }
    //console.log("STEP 10: mode =", this.$route.params.mode, ", id สำหรับ signature =", id);

    const res_acc = await api.getAccountDetail(id);
    //console.log("STEP 11: res_acc =", JSON.stringify(res_acc.data));

    this.setusername =
      res_acc.data[0].prename_e_n +
      " " +
      res_acc.data[0].firstname_e_n +
      " " +
      res_acc.data[0].lastname_e_n;
    //console.log("STEP 12: setusername =", this.setusername);

    const res_department = await api.billing_expense_getDepartmentByID(
      res_acc.data[0].department_i_d
    );
    //console.log("STEP 13: res_department =", JSON.stringify(res_department.data));

    this.department_view = res_department.data[0].name;
    //console.log("STEP 14: department_view =", this.department_view);

    if (this.$route.params.mode === "approve") {
      this.mode_edit = false;
      this.mode_approve = true;
      this.doc_title = "Approve";

      const res_app = await api.getAccountDetail(
        localStorage.getItem(server.USER_ID)
      );
      //console.log("STEP 15: res_app (approver) =", JSON.stringify(res_app.data));
      this.user_sign2 = res_app.data[0].signature;
    } else {
      this.mode_edit = true;
      this.mode_approve = false;
      this.doc_title = "Add Advance";
    }
    //console.log("STEP 16: set mode เสร็จ");

    this.user_sign = res_acc.data[0].signature;
    this.main_id = this.$route.params.id;

    this.date = new Date(this.advance_h.clear_date).toISOString().substr(0, 10);
    //console.log("STEP 17: แปลง clear_date เป็น date สำเร็จ =", this.date);

    this.showsig1 = true;
    if (this.mode_approve) {
      this.showsig2 = true;
    }
    this.dialogSignature = true;
    this.showdefaultsignature();
    this.savesig1();
    this.savesig2();
    //console.log("STEP 18: signature setup เสร็จ");

    this.$hideLoader();
    //console.log("STEP 19: จบ mounted เรียบร้อย");
  },
  methods: {
    openPreviewMaps(data) {
      // ใช้ Regular Expression เพื่อดึงพิกัดเริ่มต้นและปลายทาง
      const regex = /\(([^)]+)\)/g;
      const matches = [...data.matchAll(regex)];

      if (matches.length >= 2) {
        const origin = matches[0][1]; // พิกัดจุดเริ่มต้น (origin)
        const destination = matches[1][1]; // พิกัดจุดปลายทาง (destination)

        const url = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(
          origin
        )}&destination=${encodeURIComponent(destination)}`;
        window.open(url, "_blank");
      } else {
        console.error("ไม่พบพิกัดจุดเริ่มต้นและปลายทางในข้อมูล");
      }
    },
    async loadEmp() {
      const result = await api.getAccountslist_by_ComID(
        localStorage.getItem(server.COMPANYID)
      );

      this.emp_list = result.data;
    },
    async loadJobtitle() {
      const result = await api.getAllJobtitleByCompany(
        localStorage.getItem(server.COMPANYID)
      );

      this.jobtitle_list = result.data;
    },
    closeDialogSendmail() {
      this.dialogSendMail = false;
      // this.$router.push("/approve-advance-list");
      this.$store.state.global_push_dialog = true;
      this.setupAlertDialogPush(
        true,
        "Information Saved",
        "Information successfully saved",
        "text-h5 green--text text-center",
        "/approve-advance-list"
      );
    },
    async updateApprove(id) {
      if (id == 4 && this.approver_remark == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "Please complete all of the required fields.",
          "text-h5 red--text text-center"
        );
        this.$refs["reject approve"].focus();
        return;
      }
      this.advance_h_update_status.status = id;
      this.advance_h_update_status.approver_remark = this.approver_remark;

      this.advance_log.module_id = this.$route.params.id;
      this.advance_log.approve_id = localStorage.getItem(server.USER_ID);
      this.advance_log.approve_status = id;
      this.advance_log.approve_date = new Date();

      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });

      const res_update = await api.billing_expense_updateAdvanceH(
        this.$route.params.id,
        this.advance_h_update_status
      );
      if (res_update.status == 200) {
        const res_log = await api.billing_expense_addAdvanceLog(
          this.advance_log
        );
        // //console.log("res_log : " + JSON.stringify(res_log.status));

        if (res_log.status == 201) {
          if (id == 4) {
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "Information Saved",
              "Request successfully saved and sent to Requester.",
              "text-h5 green--text text-center",
              "/approve-advance-list"
            );
          } else {
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "Information Saved",
              "Request successfully saved and sent to accountant.",
              "text-h5 green--text text-center",
              "/approve-advance-list"
            );
          }
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "Please complete all of the required fields.",
            "text-h5 red--text text-center"
          );
        }
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "Please complete all of the required fields.",
          "text-h5 red--text text-center"
        );
      }
      loader.hide();
      // //console.log("res_update : ", JSON.stringify(res_update));
    },
    async updateRequest(id) {
      this.advance_h_update_status.status = id;
      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });

      const res_update = await api.billing_expense_updateAdvanceH(
        this.$route.params.id,
        this.advance_h_update_status
      );
      if (res_update.status == 200) {
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Information Saved",
          "Request successfully saved and sent to accountant.",
          "text-h5 green--text text-center",
          "/approve-advance-list"
        );
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "Please complete all of the required fields.",
          "text-h5 red--text text-center"
        );
      }
      loader.hide();
      // //console.log("res_update : ", JSON.stringify(res_update));
    },
    async deleteForm() {
      // alert("deleteForm");
      this.close_status = false;
      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });
      this.dialogDeleteForm = true;

      await api.billing_expense_deleteAdvanceH(this.$route.params.id);
      await api.billing_expense_deleteAdvanceD(this.$route.params.id);
      this.$store.state.global_push_dialog = true;
      this.setupAlertDialogPush(
        true,
        "Information Saved",
        "Request successfully saved and sent to Requester.",
        "text-h5 green--text text-center",
        "/approve-advance-list"
      );

      loader.hide();
    },
    async loadAdvanceCode() {
      // //console.log("loadAdvanceCode");

      let company_id = localStorage.getItem(server.COMPANYID);

      // //console.log("loadAdvanceCode company_id:" + company_id);

      const result = await api.billing_expense_getAllAdvanceCodeByCompany(
        company_id
      );

      // //console.log("loadAdvanceCode : ", JSON.stringify(result.data));
      this.advance_code = result.data;

      result.data.forEach((item) => {
        this.advance_code_list.push(item.code + " " + item.description);
      });
    },
    onSelectAdvanceCodeChange(acvance_code) {
      // var tmp = null;
      // tmp = this.customer.filter((c) => c.name.includes(search_customer));

      // this.customer_id = tmp[0].id;
      // //console.log("acvance_code : " + acvance_code);
      var tmp = acvance_code.split(" ");
      this.editedItem.advance_title = tmp[0];
      this.editedItem.description = tmp[1];
    },
    setupAlertDialog(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async saveAdvanceDraft() {
      // alert("saveAdvanceDraft");
      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });

      if (this.customer_id != 0) {
        this.advance_h.customer_id = this.customer_id;
      }
      this.advance_h.employee_id = localStorage.getItem(server.USER_ID);
      this.advance_h.department_id = localStorage.getItem(server.DEPARTMENT_ID);
      //   this.advance_h.advance_date = unity.parseDate(this.dateCurrent);
      this.advance_h.sum_amount = this.sumwithdrawamount;
      this.advance_h.clear_date = this.date;
      this.advance_h.payment_type = this.paymentType;
      this.advance_h.bank_name = this.selectbankname;
      this.advance_h.bank_number = this.bankNumber;
      this.advance_h.cheque_number = this.chequeNumber;
      this.advance_h.status = 1;
      this.advance_h.remark = this.remark;
      this.advance_h.create_by = localStorage.getItem(server.USER_ID);
      this.advance_h.create_date = unity.parseDate(this.dateCurrent);

      //   //console.log("advance_h : " + JSON.stringify(this.advance_h));
      //   //console.log("advance_d : " + JSON.stringify(this.advance_d));

      const res_h = await api.billing_expense_updateAdvanceH(
        this.$route.params.id,
        this.advance_h
      );
      //   //console.log("res_h : " + JSON.stringify(res_h.data));
      if (res_h.status == 200) {
        await api.deleteAdvanceD(this.$route.params.id);
        if (this.desserts.length > 0) {
          this.desserts.forEach((item) => {
            this.advance_d.advance_hid = this.$route.params.id;
            this.advance_d.advance_title = item.advance_title;
            this.advance_d.description = item.description;
            this.advance_d.amount = item.amount;
            // //console.log("advance_d : " + JSON.stringify(this.advance_d));
            api.addAdvanceD(this.advance_d);
          });
        }
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "Information successfully saved",
          "text-h5 green--text text-center"
        );
        this.$router.push("/approve-advance-list");
      } else {
        // alert("ไม่สามารถบันทึกได้");
        // this.messageSaveDraft = "ไม่สามารถบันทึกได้";
        // this.dialogSaveDraft = true;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
      }

      loader.hide();
    },

    async saveAdvanceRequest() {
      // alert("saveAdvanceDraft");

      if (this.advance_h.customer_id == 0) {
        // alert("กรุณาเลือกลูกค้า");
        // this.messageSaveDraft = "กรุณาเลือกลูกค้า";
        // this.dialogSaveDraft = true;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณาเลือกลูกค้า",
          "text-h5 red--text text-center"
        );

        return;
      }

      if (this.desserts.length <= 0) {
        // alert("กรุณาเลือกลูกค้า");
        // this.messageSaveDraft = "กรุณากรอกรายละเอียด Advance Detail";
        // this.dialogSaveDraft = true;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Advance Detail",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (this.paymentType == "") {
        // alert("กรุณาเลือกลูกค้า");
        // this.messageSaveDraft = "กรุณาเลือกวิธีการชำระเงิน";
        // this.dialogSaveDraft = true;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณาเลือกวิธีการชำระเงิน",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (this.paymentType == "transfer") {
        // alert("กรุณาเลือกลูกค้า");
        if (this.selectbankname == "" || this.bankNumber == null) {
          // this.messageSaveDraft = "กรุณากรอกข้อมูลธนาคารให้ถูกต้อง";
          // this.dialogSaveDraft = true;
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check your information again",
            "กรุณากรอกข้อมูลธนาคารให้ถูกต้อง",
            "text-h5 red--text text-center"
          );
          return;
        }
      } else if (this.paymentType == "cheque") {
        // alert("กรุณาเลือกลูกค้า");
        if (this.chequeNumber == "") {
          // this.messageSaveDraft = "กรุณากรอกเลขที่เช็คให้ถูกต้อง";
          // this.dialogSaveDraft = true;
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check your information again",
            "กรุณากรอกเลขที่เช็คให้ถูกต้อง",
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      if (this.user_sign == "" || this.user_sign == null) {
        // alert("กรุณาเลือกลูกค้า");
        // this.messageSaveDraft = "กรุณาเลือกลงลายมือชื่อ";
        // this.dialogSaveDraft = true;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณาเลือกลงลายมือชื่อ",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (
        this.mode_approve == true &&
        (this.user_sign2 == "" || this.user_sign2 == null)
      ) {
        // alert("กรุณาเลือกลูกค้า");
        // this.messageSaveDraft = "กรุณาเลือกลงลายมือชื่อ";
        // this.dialogSaveDraft = true;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณาเลือกลงลายมือชื่อ",
          "text-h5 red--text text-center"
        );
        return;
      }

      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });

      //   this.advance_h.customer_id = this.customer_id;
      if (this.customer_id != 0) {
        this.advance_h.customer_id = this.customer_id;
      }
      this.advance_h.employee_id = localStorage.getItem(server.USER_ID);
      this.advance_h.department_id = localStorage.getItem(server.DEPARTMENT_ID);
      //   this.advance_h.advance_date = unity.parseDate(this.dateCurrent);
      this.advance_h.sum_amount = this.sumwithdrawamount;
      this.advance_h.clear_date = this.date;
      this.advance_h.payment_type = this.paymentType;
      this.advance_h.bank_name = this.selectbankname;
      this.advance_h.bank_number = this.bankNumber;
      this.advance_h.cheque_number = this.chequeNumber;
      this.advance_h.status = 2;
      this.advance_h.remark = this.remark;
      this.advance_h.create_by = localStorage.getItem(server.USER_ID);
      this.advance_h.create_date = unity.parseDate(this.dateCurrent);

      // //console.log("advance_h : " + JSON.stringify(this.advance_h));
      // //console.log("advance_d : " + JSON.stringify(this.advance_d));

      //   const res_h = await api.addAdvanceH(this.advance_h);

      const res_h = await api.billing_expense_updateAdvanceH(
        this.$route.params.id,
        this.advance_h
      );

      if (res_h.status == 200) {
        await api.deleteAdvanceD(this.$route.params.id);
        if (this.desserts.length > 0) {
          this.desserts.forEach((item) => {
            // this.advance_d.advance_hid = res_h.data.id;
            this.advance_d.advance_hid = this.$route.params.id;
            this.advance_d.advance_title = item.advance_title;
            this.advance_d.description = item.description;
            this.advance_d.amount = item.amount;
            api.addAdvanceD(this.advance_d);
          });

          this.sendMail.name = localStorage.getItem(server.FULLNAME);
          this.sendMail.email = localStorage.getItem(
            server.APPROVE_LEVEL1_EMAIL
          );
          this.sendMail.advance_id = this.$route.params.id;
          //console.log("send_request1 : " + JSON.stringify(this.sendMail));
          const send_request = await api.sendMail(this.sendMail);

          //console.log("send_request2 : " + JSON.stringify(send_request));
          if (send_request.status == 200) {
            this.$store.state.global_push_dialog = true;
            // this.setupAlertDialog(
            //   true,
            //   "Information Saved",
            //   "บันทึกข้อมูลและส่งอีเมล์ถึงผู้อนุมัติสำเร็จ",
            //   "text-h5 green--text text-center"
            // );

            this.setupAlertDialogPush(
              true,
              "Information Saved",
              "บันทึกข้อมูลและส่งอีเมล์ถึงผู้อนุมัติสำเร็จ",
              "text-h5 green--text text-center",
              "/approve-advance-list"
            );
            // this.dialogSendMail = true;
          } else {
            // alert("ไม่สามารถบันทึกได้");
            // this.messageSaveDraft = "ไม่สามารถบันทึกได้";
            // this.dialogSaveDraft = true;
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Information Saved",
              "ไม่สามารถบันทึกได้",
              "text-h5 red--text text-center"
            );
          }
        }
      } else {
        // alert("ไม่สามารถบันทึกได้");
        // this.messageSaveDraft = "ไม่สามารถบันทึกได้";
        // this.dialogSaveDraft = true;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
      }

      loader.hide();
    },

    changeFocusText(t) {
      // alert(t);
      if (t === 1) {
        this.$refs["txtCode"].focus();
      } else if (t === 2) {
        this.$refs["txtDescription"].focus();
      } else if (t === 3) {
        if (this.editedItem.advance_title == "") {
          alert("กรุณากรอกรหัสการขออนุมัติ");
          this.$refs["txtCode"].focus();
        } else {
          this.$refs["txtAmount"].focus();
        }
      }
    },
    initialize() {
      this.sumwithdrawamount = 0;

      this.desserts.forEach((item) => {
        this.sumwithdrawamount += parseInt(item.amount, 10);
      });
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeSaveDraft() {
      this.dialogSaveDraft = false;
    },

    closeDelete() {
      this.sumwithdrawamount = 0;

      this.desserts.forEach((item) => {
        this.sumwithdrawamount += parseInt(item.amount, 10);
      });

      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    deleteItemConfirmForm() {
      // alert("deleteItemConfirmForm");
      this.deleteForm();
      this.closeDeleteForm();
    },
    closeDeleteForm() {
      // alert("closeDeleteForm");
      this.dialogDeleteForm = false;
      this.close_status = true;
      this.closeStatus();
    },

    save() {
      if (this.editedItem.advance_title == "") {
        alert("กรุณากรอกรหัสการขออนุมัติ");
        this.$refs["txtCode"].focus();
        return;
      }

      if (this.editedItem.amount == "0" || this.editedItem.amount == 0) {
        alert("กรุณากรอกจำนวนเงิน");
        this.$refs["txtAmount"].focus();
        return;
      }

      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }

      this.sumwithdrawamount = 0;

      this.desserts.forEach((item) => {
        this.sumwithdrawamount += parseInt(item.amount, 10);
      });
      //console.log("save : " + JSON.stringify(this.desserts));
      this.changeFocusText(1);
      this.close();
    },
    onSelectCustomerChange(search_customer) {
      var tmp = null;
      tmp = this.customer.filter((c) => c.name.includes(search_customer));

      this.customer_id = tmp[0].id;
      //console.log("customer : " + this.customer_id);
    },

    async loadCustomer() {
      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });

      // //console.log("loadCustomer");
      const result = await api.getAllCustomerList();
      // //console.log("result.data : ", JSON.stringify(result.data));
      this.customer = result.data;

      result.data.forEach((item) => {
        this.customer_list.push(item.name);
      });

      //   //console.log("this customer:" + JSON.stringify(this.customer));

      //   //console.log("this customer:" + this.advance_h.customer_id);
      //   var tmp = null;
      //   tmp = this.customer.filter((c) =>
      //     c.id.includes(1)
      //   );

      let cs_id = parseInt(this.advance_h.customer_id, 10);

      let fill_cus = this.customer.filter(function (c) {
        return c.id == cs_id;
      });
      //   //console.log("this customer:" + fill_cus);
      //   //console.log("this customer:" + JSON.stringify(fill_cus));
      this.customer_name = fill_cus[0].name;

      loader.hide();
    },
    submit() {
      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#F1F4F7",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(() => {
        loader.hide();
      }, 2000);
    },
    editsig1() {
      this.dialogSignature = true;
      this.lbl_date_request = false;
      this.showsig1 = true;
      this.showbuttonsavesig1 = true;
      this.$refs.firstsignaturePad.openSignaturePad();
    },
    editsig2() {
      // this.showsig2 = true;
      // this.showbuttonsavesig2 = true;
      // this.$refs.secondsignaturePad.openSignaturePad();

      this.dialogSignature = true;
      this.lbl_date_request = false;
      this.showsig2 = true;
      this.showbuttonsavesig2 = true;
      this.$refs.secondsignaturePad.openSignaturePad();
    },
    clearsig1() {
      this.lbl_date_request = false;
      this.$refs.firstsignaturePad.clearSignature();
    },
    clearsig2() {
      // this.$refs.secondsignaturePad.clearSignature();

      this.lbl_date_request = false;
      this.$refs.secondsignaturePad.clearSignature();
    },
    async savesig1() {
      if (!this.$refs.firstsignaturePad) {
        console.warn("savesig1: firstsignaturePad ยังไม่ render → ข้าม");
        return;
      }
      //console.log("signpad : savesig1");
      this.lbl_date_request = true;
      this.defaultwordbuttonsig1 = "Edit";
      const { isEmpty, data } = this.$refs.firstsignaturePad.saveSignature();
      this.showbuttonsavesig1 = false;
      this.$refs.firstsignaturePad.lockSignaturePad();
      // //console.log("user_sign : " + data);
      // //console.log("user_sign1 : " + this.user_sign);
      this.user_sign = data;
      this.account.signature = data;
      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });
      await api.updateAccount(
        localStorage.getItem(server.USER_ID),
        this.account
      );
      loader.hide();
    },
    async savesig2() {
      if (!this.$refs.secondsignaturePad) {
        console.warn("savesig2: secondsignaturePad ยังไม่ render → ข้าม");
        return;
      }
      //console.log("signpad : savesig2");
      this.lbl_date_request = true;
      this.defaultwordbuttonsig2 = "Edit";
      const { isEmpty, data } = this.$refs.secondsignaturePad.saveSignature();
      this.showbuttonsavesig2 = false;
      this.$refs.secondsignaturePad.lockSignaturePad();

      //console.log("signpad res_app", data);

      this.user_sign2 = data;

      //console.log("signpad res_app", data);
      this.account.signature = data;

      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });
      await api.updateAccount(
        localStorage.getItem(server.USER_ID),
        this.account
      );
      loader.hide();
    },
    changeradio() {
      //console.log(this.radioGroup);
      if (this.radioGroup === "cheque") {
        this.paymentType = "cheque";
        this.pickbank = false;
        this.pickcheque = true;
      } else if (this.radioGroup === "bank") {
        this.paymentType = "transfer";
        this.pickcheque = false;
        this.pickbank = true;
      } else {
        this.paymentType = "cash";
        this.pickcheque = false;
        this.pickbank = false;
      }
    },

    showdefaultsignature() {
      this.$nextTick(() => {
        // this.$refs.signaturePaddefault.fromDataURL(this.initial_data);
        // this.$refs.signaturePaddefault.lockSignaturePad();
        this.$refs.firstsignaturePad.fromDataURL(this.user_sign);
        // this.$refs.firstsignaturePad.lockSignaturePad();
        this.$refs.secondsignaturePad.fromDataURL(this.user_sign2);
        // this.$refs.secondsignaturePad.lockSignaturePad();
      });
    },
  },
  async beforeCreate() {
    //console.log("beforeCreate");
    // this.mounted();
  },
  async created() {
    // this.showdefaultsignature();
  },
};
</script>

<style scoped>
.description-text {
  cursor: pointer !important;
  transition: color 0.3s ease !important;
}

.description-text:hover {
  color: darkblue !important;
  /* สีที่เปลี่ยนเมื่อ hover */
}

.text-left {
  color: aliceblue;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}

.v-autocomplete.v-input>.v-input__control>.v-input__slot {
  min-height: 10px;
}

.widthsizeformadvance {
  width: 60%;
}

.bd-block-tb {
  border-block: 1px solid gray;
  writing-mode: horizontal-tb;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.bd-block-lr {
  border-block: 1px solid gray;
  writing-mode: vertical-lr;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.widthsize80formadvance {
  width: 80%;
}

.heightsize55formadvance {
  height: 55px;
}

.heightsize80performadvance {
  height: 60%;
}

.heightsize70formadvance {
  height: 70px;
}

.widthsize8055formadvance {
  width: 80px;
  height: 55px;
}

.advance-text-height {
  height: 70px;
}

.some-other-style {
  background: blue;
}

.my-header-style {
  color: #ffffff !important;
  background: #515151;
}

.data-table-button {
  color: #9e3b1b;
}

.my-header2-style {
  color: #ffffff !important;
  background: #515151;
  width: 120px;
}

.my-header3-style {
  color: #ffffff !important;
  background: #515151;
  width: 80px;
}

.my-header4-style {
  color: #ffffff !important;
  background: #515151;
  width: 150px;
}
</style>
